<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="项目名称"
                        prop="keyword">
            <el-input placeholder="请输入名称/编号模糊搜索"
                      clearable
                      v-model="search.keyword"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <!--<el-button type="primary"-->
                   <!--size="small"-->
                   <!--icon="sj-icon-export"-->
                   <!--@click="onExportPage()"></el-button>-->
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="projectid"
                         label="项目ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="number"
                         label="项目编号"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="项目名称"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="budget"
                         label="项目预算"></el-table-column>
        <el-table-column prop="executive_budget"
                         label="执行预算"></el-table-column>
        <el-table-column prop="assigned_budget"
                         label="已分配">
          <template slot-scope="scope">
              <span>{{scope.row.assigned_budget ? scope.row.assigned_budget : 0}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cost"
                         label="已使用">
          <template slot-scope="scope">
          <span>{{scope.row.cost ? scope.row.cost : 0}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="audit_status"
                         :formatter="statusFormat"
                         label="状态"></el-table-column>
        <el-table-column prop="createtime"
                         :formatter="dateFormat"
                         label="创建时间"></el-table-column>
        <el-table-column prop="updatetime"
                         :formatter="dateFormat"
                         label="最后更新时间"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/executive-budget/detail/${scope.row.projectid}`">
                <el-button size="mini"
                           type="primary">编辑
                </el-button>
              </router-link>
              <el-button size="mini"
                         @click="commitAudit(scope.row.projectid, 2)"
                         v-if="scope.row.audit_status === 1">提交审批</el-button>

              <el-button size="mini"
                         type="info"
                         @click="editStatus(scope.row.projectid, 3)" v-if="scope.row.audit_status === 2">通过
              </el-button>

              <el-button type="danger"
                         size="mini"
                         @click="editStatus(scope.row.projectid, 4)" v-if="scope.row.audit_status === 2">驳回
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../executive-budget.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      },
      exportHeader: [
        {
          key: 'projectid',
          text: '项目ID',
        },
        {
          key: 'name',
          text: '执行预算分配名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    ...Vuex.mapState({
      statusMap: state => state.executiveBudget.options.status,
    }),
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getExecutiveBudgetTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    dateFormat (row, column, cellValue, index) {
      return filter.formatDate(cellValue * 1000)
    },
    statusFormat (row, column, cellValue, index) {
      const statusMap = this.statusMap
      for (let i in statusMap) {
        if (statusMap.hasOwnProperty(i) && statusMap[i].value === cellValue * 1) {
          return statusMap[i].label
        }
      }
    },
    editStatus (id, status) {
      let info
      if (status === 2) {
        info = '提交审批'
      } else if (status === 3) {
        info = '通过执行预算'
      } else {
        info = '驳回执行预算'
      }
      this.$confirm('确认' + info + '，是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('editExecutiveBudgetStatus', {id: id, audit_status: status}).then(() => {
          this.$message.success('操作成功')
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    commitAudit (id, status) {
      this.$confirm('确认提交审批，是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('updateExecutiveBudgetAudit', {id: id, audit_status: status}).then(() => {
          this.$message.success('操作成功')
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/executive-budget/pages/ExecutiveBudgetTable.vue